const initialState = { loadingSilosParaGrafico: true }
export const reducerGraficoSilos = (state = initialState, { type, loading, data }) => {
  switch (type) {
    case 'UPDATE_GRAFICO_DE_SILOS':
      return {
        ...state,
        loadingSilosParaGrafico: loading,
        silosParaGrafico: data
      }
    default: return state
  }
}
